// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__3WzTR","Search__element":"Search_Search__element__dHCYE","slide-in-left":"Search_slide-in-left__IJ8c8"};